export default __webpack_public_path__ + "static/media/thank_you.24249d88.svg";